import palette from '@lib/core/src/theme/palette';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, Stack, styled, Switch, SwitchProps } from '@mui/material';

export const AgentConfigContainer = styled(Box)(() => ({
  display: 'flex',
  borderRadius: '16px',
  overflow: 'hidden',
  flex: 1,
  height: '100%'
}));

export const DetailsContainer = styled(Stack)(() => ({
  flex: 1
}));

export const DetailsHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const IsActiveSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45'
        })
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600]
      })
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3
      })
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D'
    })
  }
}));

export const DataSourcesContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '8px 12px',
  borderRadius: '8px',
  background: palette.white
}));

export const TemplateCardIconContainer = styled(Box)(() => ({
  borderRadius: '4px',
  backgroundColor: palette.grey[800],
  height: '32px',
  width: '32px',
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const TemplateCardContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  padding: '12px 16px',
  borderRadius: '4px',
  border: `1px solid ${palette.grey[1200]}`
}));

export const AgentProcessCardTitle = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px',
  padding: '10px 12px',
  fontSize: '12px',
  color: palette.grey[500],
  backgroundColor: palette.white,
  borderBottom: `1px solid ${palette.grey[1200]}`
}));

export const AgentProcessCardContainer = styled(Stack)(() => ({
  gap: '12px',
  borderRadius: '12px',
  paddingBottom: '12px',
  backgroundColor: palette.white,
  maxWidth: '320px',
  margin: 'auto',
  border: `1px solid ${palette.grey[1200]}`,
  boxShadow: '0px 4px 6px -4px rgba(24, 39, 75, 0.12), 0px 8px 8px -4px rgba(24, 39, 75, 0.08)'
}));

export const ArrowFlowProcess = styled(ArrowRightAltIcon)(() => ({
  transform: 'rotate(90deg)',
  margin: '13px auto',
  display: 'block',
  fill: palette.grey[400],
  fontSize: '32px'
}));
